<template>
  <div class="page-content" v-if="data">
    <div class="page-tips">数据来源于爱科会易、艾会网等</div>
    <div class="search-form" style="margin-top: 10px;">
      <!-- 地区选择 -->
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label" style="line-height: 30px;padding: 3px 0px;" >会议地区：</div>
          <div class="search-form-field-content v-center">
            <div
                class="tag-select-item"
                v-for="region in regions"
                :key="region.code"
                :class="{'selected': selectedRegion === region.code}"
                @click="handleRegionChange(region.code)">
              {{ region.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 国家选择 -->
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label" style="line-height: 30px;padding: 3px 0px;">会议国家：</div>
          <div class="search-form-field-content v-center">
            <div
                class="tag-select-item"
                v-for="country in filteredCountries"
                :key="country.code"
                :class="{'selected': selectedCountry === country.code}"
                @click="handleCountryChange(country.code)">
              {{ country.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label">会议时间：</div>
          <div class="search-form-field-content">
            <tag-select :tags="['已结束','排期中','进行中']" v-model="searchForm.state"></tag-select>
            <el-date-picker style="width: 250px;margin-left: 10px;" clearable
                            v-model="searchForm.dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期" size="small" unlink-panels
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="search-form-field">
          <div class="search-form-field-label">主办方：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.zbdw" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
        <div class="search-form-field">
          <div class="search-form-field-label">承办方：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.cbdw" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
      </div>
      <div class="search-form-row">
        <div class="search-form-field">
          <div class="search-form-field-label">会议：</div>
          <div class="search-form-field-content v-center">
            <el-input v-model="searchForm.zhmcLike" style="width: 200px;" size="mini"></el-input>
          </div>
        </div>
      </div>
      <div class="search-form-bottom">
        <el-button type="primary" @click="search">检索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
    <div style="background-color: #FFFFFF;padding: 20px;margin-top: 20px;">
      <el-table :data="data.content" stripe class="large-font-table">
        <el-table-column prop="zhmc" label="会议" show-overflow-tooltip>
          <a class="link" slot-scope="{row}" :href="$router.resolve({path:'/huiyi/abroad-details',query:{id:row.id}}).href">{{row.zhmc}}</a>
        </el-table-column>
        <el-table-column prop="country" label="国家" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" width="240">
          <span slot-scope="{row}">{{row.jbkssj}} ~ {{row.jbjssj}}</span>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" background
                     :total="data.totalElements" :current-page="data.number+1"
                     @current-change="loadData">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api";
import TagSelect from "./TagSelect";
import moment from "moment";
const DATE_FMT='YYYY-MM-DD';
export default {
  name: "AbroadHuiyiList",
  components:{TagSelect},
  data(){
    return {
      searchForm:{
        state: null,
        dateRange:null,
        zhmcLike:null,
        zbdw:null,
        cbdw:null
      },
      searchParams:{
        province:null,
        state:null,
        startDate:null,
        endDate:null,
        zhmcLike:null,
        zbdw:null,
        cbdw:null,
      },
      data:null,
      // 当前选中的地区和国家编码
      selectedRegion: '0', // 默认地区代码（如：2代表欧洲）
      selectedCountry: '178', // 默认国家代码
      // 地区列表
      regions: [
        { code: '0', name: '全部' },
        { code: '2', name: '欧洲' },
        { code: '3', name: '亚洲' },
        { code: '4', name: '北美洲' },
        { code: '5', name: '大洋洲' },
        { code: '6', name: '非洲' },
        { code: '7', name: '南美洲' },
      ],
      countriesData: {
        '0': [ // 全部
          { code: '178', name: '全部' },
          { code: '1', name: '德国' },
          { code: '2', name: '法国' },
          { code: '3', name: '意大利' },
          { code: '4', name: '俄罗斯' },
          { code: '5', name: '英国' },
          { code: '6', name: '西班牙' },
          { code: '12', name: '日本' },
          { code: '13', name: '韩国' },
          { code: '14', name: '印度' },
          { code: '21', name: '加拿大' },
          { code: '22', name: '墨西哥' },
          { code: '23', name: '美国' },
          { code: '24', name: '巴拿马' },
          { code: '25', name: '牙买加' },
          { code: '26', name: '阿鲁巴' },
          { code: '27', name: '哥斯达黎加' },
          { code: '28', name: '澳大利亚' },
          { code: '29', name: '新西兰' },
          { code: '30', name: '马耳他' },
          { code: '31', name: '黑山' },
          { code: '32', name: '摩纳哥' },
          { code: '33', name: '格鲁吉亚' },
          { code: '34', name: '马其顿' },
          { code: '35', name: '阿塞拜疆' },
          { code: '36', name: '摩尔多瓦' },
          { code: '37', name: '爱沙尼亚' },
          { code: '38', name: '荷兰' },
          { code: '39', name: '瑞士' },
          { code: '40', name: '捷克' },
          { code: '41', name: '希腊' },
          { code: '42', name: '奥地利' },
          { code: '43', name: '土耳其' },
          { code: '44', name: '波兰' },
          { code: '45', name: '丹麦' },
          { code: '46', name: '瑞典' },
          { code: '47', name: '葡萄牙' },
          { code: '48', name: '卢森堡' },
          { code: '49', name: '爱尔兰' },
          { code: '50', name: '斯洛文尼亚' },
          { code: '51', name: '芬兰' },
          { code: '52', name: '白俄罗斯' },
          { code: '53', name: '匈牙利' },
          { code: '54', name: '挪威' },
          { code: '55', name: '波黑' },
          { code: '56', name: '克罗地亚' },
          { code: '57', name: '斯洛伐克' },
          { code: '58', name: '立陶宛' },
          { code: '59', name: '保加利亚' },
          { code: '60', name: '乌克兰' },
          { code: '61', name: '罗马尼亚' },
          { code: '62', name: '比利时' },
          { code: '63', name: '埃及' },
          { code: '64', name: '博茨瓦纳' },
          { code: '65', name: '喀麦隆' },
          { code: '66', name: '赞比亚' },
          { code: '67', name: '肯尼亚' },
          { code: '68', name: '坦桑尼亚' },
          { code: '69', name: '尼日利亚' },
          { code: '70', name: '南非' },
          { code: '71', name: '阿尔及利亚' },
          { code: '72', name: '埃塞俄比亚' },
          { code: '73', name: '巴西' },
          { code: '74', name: '阿根廷' },
          { code: '75', name: '智利' },
          { code: '76', name: '哥伦比亚' },
          { code: '77', name: '秘鲁' },
          { code: '78', name: '越南' },
          { code: '79', name: '阿联酋' },
          { code: '80', name: '新加坡' },
          { code: '81', name: '印尼' },
          { code: '82', name: '马来西亚' },
          { code: '83', name: '泰国' },
          { code: '84', name: '菲律宾' },
          { code: '85', name: '孟加拉' },
          { code: '86', name: '斯里兰卡' },
          { code: '87', name: '以色列' },
          { code: '88', name: '哈萨克斯坦' },
          { code: '89', name: '乌兹别克斯坦' },
          { code: '90', name: '土库曼斯坦' },
          { code: '91', name: '巴基斯坦' },
          { code: '92', name: '沙特阿拉伯' },
          { code: '93', name: '卡塔尔' },
          { code: '94', name: '阿曼' },
          { code: '95', name: '蒙古' },
          { code: '177', name: '伊朗' },
          { code: '97', name: '尼泊尔' },
          { code: '98', name: '约旦' },
          { code: '99', name: '伊拉克' },
          { code: '181', name: '厄瓜多尔' },
          { code: '182', name: '玻利维亚' },
          { code: '183', name: '巴拉圭' },
          { code: '184', name: '苏里南' },
          { code: '185', name: '津巴布韦' },
          { code: '186', name: '突尼斯' },
          { code: '187', name: '加纳' },
          { code: '188', name: '安哥拉' },
          { code: '189', name: '卢旺达' },
          { code: '190', name: '苏丹' },
          { code: '191', name: '摩洛哥' },
          { code: '192', name: '马达加斯加' },
          { code: '193', name: '塞内加尔' },
          { code: '194', name: '波多黎各' },
          { code: '195', name: '古巴' },
        ],
        '2': [ // 欧洲
          { code: '178', name: '全部' },
          { code: '1', name: '德国' },
          { code: '2', name: '法国' },
          { code: '3', name: '意大利' },
          { code: '4', name: '俄罗斯' },
          { code: '5', name: '英国' },
          { code: '6', name: '西班牙' },
          { code: '30', name: '马耳他' },
          { code: '31', name: '黑山' },
          { code: '32', name: '摩纳哥' },
          { code: '33', name: '格鲁吉亚' },
          { code: '34', name: '马其顿' },
          { code: '35', name: '阿塞拜疆' },
          { code: '36', name: '摩尔多瓦' },
          { code: '37', name: '爱沙尼亚' },
          { code: '38', name: '荷兰' },
          { code: '39', name: '瑞士' },
          { code: '40', name: '捷克' },
          { code: '41', name: '希腊' },
          { code: '42', name: '奥地利' },
          { code: '43', name: '土耳其' },
          { code: '44', name: '波兰' },
          { code: '45', name: '丹麦' },
          { code: '46', name: '瑞典' },
          { code: '47', name: '葡萄牙' },
          { code: '48', name: '卢森堡' },
          { code: '49', name: '爱尔兰' },
          { code: '50', name: '斯洛文尼亚' },
          { code: '51', name: '芬兰' },
          { code: '52', name: '白俄罗斯' },
          { code: '53', name: '匈牙利' },
          { code: '54', name: '挪威' },
          { code: '55', name: '波黑' },
          { code: '56', name: '克罗地亚' },
          { code: '57', name: '斯洛伐克' },
          { code: '58', name: '立陶宛' },
          { code: '59', name: '保加利亚' },
          { code: '60', name: '乌克兰' },
          { code: '61', name: '罗马尼亚' },
          { code: '62', name: '比利时' },
        ],
        '3': [ // 亚洲
          { code: '178', name: '全部' },
          { code: '12', name: '日本' },
          { code: '13', name: '韩国' },
          { code: '14', name: '印度' },
          { code: '78', name: '越南' },
          { code: '79', name: '阿联酋' },
          { code: '80', name: '新加坡' },
          { code: '81', name: '印尼' },
          { code: '82', name: '马来西亚' },
          { code: '83', name: '泰国' },
          { code: '84', name: '菲律宾' },
          { code: '85', name: '孟加拉' },
          { code: '86', name: '斯里兰卡' },
          { code: '87', name: '以色列' },
          { code: '88', name: '哈萨克斯坦' },
          { code: '89', name: '乌兹别克斯坦' },
          { code: '90', name: '土库曼斯坦' },
          { code: '91', name: '巴基斯坦' },
          { code: '92', name: '沙特阿拉伯' },
          { code: '93', name: '卡塔尔' },
          { code: '94', name: '阿曼' },
          { code: '95', name: '蒙古' },
          { code: '177', name: '伊朗' },
          { code: '97', name: '尼泊尔' },
          { code: '98', name: '约旦' },
          { code: '99', name: '伊拉克' },
        ],
        '4': [ // 北美洲
          { code: '178', name: '全部' },
          { code: '21', name: '加拿大' },
          { code: '22', name: '墨西哥' },
          { code: '23', name: '美国' },
          { code: '24', name: '巴拿马' },
          { code: '25', name: '牙买加' },
          { code: '26', name: '阿鲁巴' },
          { code: '27', name: '哥斯达黎加' },
          { code: '194', name: '波多黎各' },
          { code: '195', name: '古巴' },
        ],
        '5': [ // 大洋洲
          { code: '178', name: '全部' },
          { code: '28', name: '澳大利亚' },
          { code: '29', name: '新西兰' }
        ],
        '6': [ // 非洲
          { code: '178', name: '全部' },
          { code: '63', name: '埃及' },
          { code: '64', name: '博茨瓦纳' },
          { code: '65', name: '喀麦隆' },
          { code: '66', name: '赞比亚' },
          { code: '67', name: '肯尼亚' },
          { code: '68', name: '坦桑尼亚' },
          { code: '69', name: '尼日利亚' },
          { code: '70', name: '南非' },
          { code: '71', name: '阿尔及利亚' },
          { code: '72', name: '埃塞俄比亚' },
          { code: '185', name: '津巴布韦' },
          { code: '186', name: '突尼斯' },
          { code: '187', name: '加纳' },
          { code: '188', name: '安哥拉' },
          { code: '189', name: '卢旺达' },
          { code: '190', name: '苏丹' },
          { code: '191', name: '摩洛哥' },
          { code: '192', name: '马达加斯加' },
          { code: '193', name: '塞内加尔' },
        ],
        '7': [ // 南美洲
          { code: '178', name: '全部' },
          { code: '73', name: '巴西' },
          { code: '74', name: '阿根廷' },
          { code: '75', name: '智利' },
          { code: '76', name: '哥伦比亚' },
          { code: '77', name: '秘鲁' },
          { code: '181', name: '厄瓜多尔' },
          { code: '182', name: '玻利维亚' },
          { code: '183', name: '巴拉圭' },
          { code: '184', name: '苏里南' },
        ],
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    // 根据当前选中的地区动态筛选国家列表
    filteredCountries() {
      return this.countriesData[this.selectedRegion] || [];
    }
  },
  methods:{
    // 处理地区选择变化
    handleRegionChange(regionCode) {
      this.selectedRegion = regionCode;
      // 选中地区后，重置国家选择为 "全部"
      this.selectedCountry = '178';
    },
    // 处理国家选择变化
    handleCountryChange(countryCode) {
      this.selectedCountry = countryCode;
    },
    async init(){
      if(this.$route.query.state){
        this.searchForm.state=this.$route.query.state
      }
      if(this.$route.query.startDate&&this.$route.query.endDate){
        this.searchForm.dateRange=[
          moment(this.$route.query.startDate,DATE_FMT),
          moment(this.$route.query.endDate,DATE_FMT)
        ]
      }
      this.searchForm.zbdw=this.$route.query.zbdw
      this.searchForm.cbdw=this.$route.query.cbdw
      await this.search()
    },
    async search(){
      if(this.searchForm.state==='已结束'){
        this.searchParams.state='END'
      }else if(this.searchForm.state==='排期中'){
        this.searchParams.state='PENDING'
      }else if(this.searchForm.state==='进行中'){
        this.searchParams.state='OPENING'
      }else{
        this.searchParams.state=null
      }
      if (this.searchForm.dateRange) {
        this.searchParams.startDate = moment(this.searchForm.dateRange[0]).format(DATE_FMT)
        this.searchParams.endDate = moment(this.searchForm.dateRange[1]).format(DATE_FMT)
      }else{
        this.searchParams.startDate = null
        this.searchParams.endDate = null
      }
      this.searchParams.zhmcLike=this.searchForm.zhmcLike
      this.searchParams.zbdw=this.searchForm.zbdw
      this.searchParams.cbdw=this.searchForm.cbdw
      if(this.selectedRegion==='0'&&this.selectedCountry==='178'){
        this.searchParams.country =null
      }else if(this.selectedCountry==='178'){
        this.searchParams.country =this.filteredCountries.map(i=>i.name)
      }else{
        this.searchParams.country=this.filteredCountries.find(i=>i.code===this.selectedCountry).name
      }
      await this.loadData(1)
    },
    async reset(){
      this.searchForm.state=null
      this.searchForm.dateRange=null
      this.searchForm.zhmcLike=null
      this.searchForm.zbdw=null
      this.searchForm.cbdw=null
      this.selectedRegion='0'
      this.selectedCountry='178'
    },
    async loadData(page){
      const params={
        ...this.searchParams,
        abroad: true,
        type:'会议',
        page:page-1,
        size:10,
        sort:'jbkssj,DESC'
      }
      this.data=(await api.listZhanhui(params)).data
    }
  }
}
</script>

<style scoped>

</style>
